import share from './share/share.js';
import browerOpen from './brower-open/brower-open.js';
import guideTeacher from './guide-teacher/guide-teacher.js';
import endCardsConfirm from './end-card/end-card.js';
import systemUpdate from './system-update/system-update.js';
import systemKefu from './system-kefu/system-kefu.js';

let popups = [share, browerOpen, guideTeacher, endCardsConfirm, systemUpdate, systemKefu];

let popup = {};

popups.forEach(item => {
  Vue.use(item, {
    router: VueRouter.router,
    root: popup,
  });
});

export default popup;
